import { Box, Card, CardContent, Typography, Grid, Autocomplete, TextField, Button, Checkbox, Switch } from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {getLocations} from '../utils';
import { updateSecurebaseAccess } from "redux/actions/addEditWorker";

const Securebase = ({handleChange}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const workerData = location.state && location.state.worker ? location.state.worker : null;
    const empId = location.state && location.state.empId ? location.state.empId : '';
    const approveForMgr = location.state && location.state.approveForManager
                              ? location.state.approveForManager : {};
    const user = useSelector((state) => state.user.auth.user);  
    const securebaseData = useSelector(state => state.addEditWorker.workerRoles.SECUREBASE || {});
    const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
    const imtRole = useSelector((state) => state.user.imtRole || null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
    const [disableSave, setDisableSave] = useState(true);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [roleOptions, setRoleOptions] = useState([ "Supervisor", "Worker"])
    const [readOnly, setReadOnly] = useState(true);


  useEffect(() => {
      if(!districtOptions.length >0){
        getLocations().then(data => {
          const { securebaseEnableList=[] } = data;
          setDistrictOptions([...securebaseEnableList]);
        });
      }
  }, [])

  useEffect(() => {
    console.log("IMTime Role", imtRole)
   if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
  },[imtRole])

  useEffect(() => {
    if(securebaseData && Object.keys(securebaseData).length>0){
      setFormValues(_.cloneDeep(securebaseData));
    }
  }, [securebaseData])

  useEffect(() => {
    console.log("SECUREBASE formValues", formValues);
    if(formValues?.sbDistricts?.length>0 && districtOptions.length>0){
      console.log("SECUREBASE buildings", districtOptions.length);
      const buildingOptions = [];
      districtOptions.forEach(record => {
        if(formValues?.sbDistricts?.includes(record?.district)){
          const allBuildings = record?.buildings || {};
          console.log("SECUREBASE buildings", formValues?.sbDistricts, allBuildings);
          Object.keys(allBuildings).forEach(building => {
            if(allBuildings[building].sbEnabled === true){
              const option = {
                buildingID: building,
                districtID: record?.district || "",
                branchId: allBuildings[building]?.sbBranchId || "",
                sbRegion: allBuildings[building]?.sbRegion || "",
              }
              buildingOptions.push(option);
            } 
          })
        }
      })
      setBuildingOptions(buildingOptions);
    }else{
      setBuildingOptions([]);
    }
    validForm(formValues);
  } ,[formValues, districtOptions])

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.role){
        errors['role'] = "Field is required";
      }
      if(!formValues?.sbBuildings?.length > 0){
        errors['sbBuildings'] = "Field is required";
      }
      if(!formValues?.sbDistricts?.length > 0){
        errors['sbDistricts'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, securebaseData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        throw new Error("Invalid data. Please check!")
      }
      
      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        role: formValues?.role || "",
        sbDistricts: formValues?.sbDistricts || [],
        sbBuildings: formValues?.sbBuildings || [],
        isActive: formValues?.isActive ? true : false,
        activityFamilyId: 'SECUREBASE'
      }
      console.log("SECUREBASE submit", formValues, data);
      const response = await dispatch(updateSecurebaseAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "SECUREBASE Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "SECUREBASE Access update failed.",
          severity: 'error'
        })
      }


    }catch(error){
      console.log("SECUREBASE handleSumit error", error);
      setSnackControl({
        open: true,
        message: "SECUREBASE Access failed to submit.",
        severity: "error"
      })
    }
  }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                Securebase
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    
                    marginBottom={2}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                         inputProps={{ 'aria-label': 'Enable SECUREBASE Role switch' }}
                         checked={formValues?.isActive}
                         onChange={(e) => {
                           let checked = e.target.checked;
                           setFormValues({ ...formValues, isActive: checked });
                         }}
                         disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginTop={3}>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                        <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Select District" 
                                required 
                                error= {formErrors?.sbDistricts}
                                helperText= {formErrors?.sbDistricts}
                              />
                            )}
                            id="sbDistricts"
                            name="sbDistricts"
                            size="small"
                            options={districtOptions || []}
                            multiple
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.district || option}
                            isOptionEqualToValue={(option, value) => option === value || option.district == value}
                            value={formValues?.sbDistricts || []}
                            onChange={(e, v) => {
                              const districtIds = v ? v.map(record => record?.district || record) :[];
                              setFormValues(prevState => ({
                                ...prevState,
                                sbDistricts: districtIds,
                                sbBuildings:  prevState?.sbBuildings ? 
                                prevState?.sbBuildings.filter(record => districtIds.includes(record?.districtID)) : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                        <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} w
                                label="Select Building" 
                                required
                                error= {formErrors?.sbBuildings}
                                helperText= {formErrors?.sbBuildings}
                              />
                            )}
                            id="sbBuildings"
                            name="sbBuildings"
                            size="small"
                            disableCloseOnSelect
                            options={buildingOptions || []}
                            getOptionLabel={option => option.buildingID}
                            isOptionEqualToValue={(option, value) => value?.buildingID && value?.buildingID == option.buildingID}
                            multiple
                            value={formValues?.sbBuildings || []}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({
                                ...prevState,
                                sbBuildings: v ? v : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Autocomplete
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Role"
                                required
                                error = {formErrors?.role}
                                helperText= {formErrors?.role}
                              />
                            )}
                            id="role"
                            name="role"
                            size="small"
                            options={roleOptions || []}
                            //readOnly 
                            value={formValues?.role || ""}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({...prevState, role: v? v : ''}));
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 40, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled={disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default Securebase;
